import { DeleteWorkspaceIcon } from '~/constants/icon'

interface DeleteConfirmModalProps {
  isOpen: boolean
  onClose: () => void
  onConfirm: () => void
  title: string
  description: string
  itemsToDelete: string[]
  confirmButtonText: string
}

export const DeleteConfirmModal = ({
  isOpen,
  onClose,
  onConfirm,
  title,
  description,
  itemsToDelete,
  confirmButtonText
}: DeleteConfirmModalProps) => {
  if (!isOpen) return null

  return (
    <div className='fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50'>
      <div className='bg-white rounded-2xl p-6 w-full mx-4 shadow-xl max-w-[calc(100vw-24px)] sm:w-[638px] h-auto sm:h-[320px]'>
        <div className='flex items-start mb-4 gap-3'>
          <div>
            <DeleteWorkspaceIcon />
          </div>
          <div className='flex flex-col h-full'>
            <div>
              <h3 className='text-lg font-semibold text-gray-900 mb-2 select-none'>{title}</h3>
              <p className='text-gray-600 text-sm mb-4 select-none'>{description}</p>
              <ul className='text-sm text-gray-600 space-y-1 mb-6 select-none'>
                {itemsToDelete.map((item, index) => (
                  <li key={index}>• {item}</li>
                ))}
              </ul>
            </div>
            <div className='flex justify-end space-x-3 mt-5'>
              <button
                onClick={onClose}
                className='px-4 py-2 text-gray-700 bg-gray-100 rounded-lg hover:bg-gray-200 transition-colors select-none'
              >
                Cancel
              </button>
              <button
                onClick={onConfirm}
                className='px-4 py-2 bg-red-600 text-white rounded-lg hover:bg-red-700 transition-colors select-none'
              >
                {confirmButtonText}
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>
  )
}
